module.exports = __webpack_public_path__ + "img/couples-085.bfc2f6d4.jpg";